import { theme } from '@terraware/web-components';

// This import is needed to get the types for customized Palette, unfortunately this is the easiest fix for now.
/* eslint-disable @typescript-eslint/no-unused-vars */
import TerrawareThemeOptions from '@terraware/web-components/style-dictionary-dist/TerrawareTheme';

export default theme;
